@if (visible()) {
  <div class="hx-release-banner" [class.hx-release-banner--warning]="warning()">
    <div class="hx-release-banner__content">
      <!-- Icon -->
      <div class="hx-release-banner__icon">
        <hx-icon svgIcon="ccs-sparkles" size="small" class="hx-release-banner__release-icon" />
      </div>

      <span class="hx-release-banner__message">{{ label() }}</span>

      <!-- Link -->
      <a
        class="hx-release-banner__link"
        [href]="viewLink()"
        [attr.target]="openInNewTab() ? '_blank' : '_self'"
        [attr.rel]="openInNewTab() ? 'noopener noreferrer' : null"
        (click)="onViewClick()">
        <span>View details</span>
        <hx-icon svgIcon="ccs-box-arrow-up-right" [size]="12" />
      </a>

      <!-- Dismiss -->
      <button class="hx-release-banner__dismiss" aria-label="Dismiss release banner" (click)="onDismiss()">
        <hx-icon svgIcon="ccs-x" size="small" />
      </button>
    </div>
  </div>
}
